module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-clients"
  }, [_c('div', {
    staticClass: "panelheader border-1"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/admin/clients'
      }
    }
  }, [_vm._v(_vm._s(_vm.pageName))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrapper"
  }, [_c('el-button', {
    attrs: {
      "type": "add"
    },
    on: {
      "click": _vm.onNewClient
    }
  }, [_vm._v("New Client")])], 1)]), _vm._v(" "), (!_vm.reloading) ? _c('div', {
    staticClass: "clients"
  }, [(_vm.newClient) ? _c('div', [_c('newclient', {
    on: {
      "close": _vm.onClose
    }
  })], 1) : (_vm.editClient) ? _c('div', [_c('editclient', {
    attrs: {
      "clientData": _vm.clientData
    },
    on: {
      "close": _vm.onClose
    }
  })], 1) : _c('div', [_c('clienttable', {
    on: {
      "editClient": _vm.onEditClient,
      "deleteClient": _vm.onDeleteClient
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "schedules",
    staticStyle: {
      "margin-top": "32px"
    }
  }, [_c('el-collapse', {
    attrs: {
      "accordion": ""
    },
    model: {
      value: (_vm.activeCollapse),
      callback: function($$v) {
        _vm.activeCollapse = $$v
      },
      expression: "activeCollapse"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": "Schedules",
      "name": "1"
    }
  }, [_c('div', [_vm._v(" Total items scheduled: " + _vm._s(_vm.formattedSchedules.length) + " ")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.formattedSchedules,
      "empty-text": "Nothing scheduled.",
      "default-sort": "time"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Booking ID",
      "prop": "booking_id",
      "header-align": "center",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v("\n                " + _vm._s(_vm.idColumn(props.row)) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "On/Off",
      "prop": "on",
      "header-align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [(props.row.on) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("\n                  ON\n                ")]) : _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("\n                  OFF\n                ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Time",
      "prop": "time",
      "header-align": "center",
      "sortable": "",
      "formatter": _vm.timeFormat
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Raw",
      "prop": "raw",
      "header-align": "center"
    }
  })], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cddff0f","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Clients/Clients.vue
// module id = 985
// module chunks = 11